export default {
  currency: "$",
  pricesToken: "6lvZ3DHybTOvsdrJcO2GDEnXTolm2ubk",
  googleAppUrl:
    "https://play.google.com/store/apps/details?id=com.prizmos.carista&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
  appleAppUrl: "https://itunes.apple.com/app/id954363569",
  caristaFeedBackUrl: "https://help.carista.com/hc/en-us/requests/new",
  caristaFaqUrl: "https://help.carista.com/hc/",
  caristaBlogUrl: "https://blog.caristaapp.com/",

  // Feature flags:

  ENABLE_CAMPAIGNS: true,
  OBD_PHASEOUT_EXPERIMENT_ENABLED: false, // PRBL-12189
  FILTER_MAN_BRAND_FROM_SUPPORTED_CARS_SECTION: true, // PRBL-12467

  // Helper flags for TESTING purposes:

  USE_CAMPAIGN_MOCKED_DATA: false, // - If true, the app will use the mocked data for campaigns
};
